module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: " weex-ct weex-cell",
    class: ['dof-cell', _vm.clickActivied && 'active-cell', _vm.hasTopBorder && 'cell-top-border', _vm.hasBottomBorder && 'cell-bottom-border', _vm.hasMargin && 'cell-margin', _vm.hasVerticalIndent && 'cell-indent', _vm.desc && 'has-desc'],
    style: (_vm._px2rem(_vm.outputCellStyle, 75)),
    attrs: {
      "canEdit": _vm.canEdit,
      "weex-type": "cell",
      "data-evt-click": "",
      "data-evt-delete": "",
      "data-evt-longpress": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "delete": _vm.onDelete,
      "longpress": function($event) {
        $event.stopPropagation();
        return _vm.showEdit($event)
      },
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cellClicked($event)
      }
    }
  }, [_vm._t("itemImg", [(_vm.itemImg && _vm.itemImg != '') ? _c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("contain"),
      expression: "\"contain\""
    }],
    staticClass: "item-img weex-el weex-image",
    attrs: {
      "src": _vm.itemImg,
      "resize": "contain",
      "data-img-src": _vm.itemImg,
      "weex-type": "image"
    }
  }) : _vm._e()], {}), _vm._v(" "), _vm._t("label", [(_vm.label) ? _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "cell-label-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()], {}), _vm._v(" "), _c('div', {
    staticClass: "cell-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("title", [_c('p', {
    staticClass: "cell-content weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.desc) ? _c('p', {
    staticClass: "cell-desc-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()], {})], 2), _vm._v(" "), _vm._t("value", null, {}), _vm._v(" "), _vm._t("text", null, {}), _vm._v(" "), _vm._t("rightText", [(_vm.rightText) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: ({
      paddingRight: _vm._px2rem(_vm.hasArrow ? '24px' : '0px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "right-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightText))])]) : _vm._e()], {}), _vm._v(" "), (_vm.hasArrow) ? _c('figure', {
    staticClass: "cell-arrow-icon weex-el weex-image",
    style: ({
      top: _vm._px2rem((_vm.height - 24) / 2 + 'px', 75)
    }),
    attrs: {
      "src": _vm.arrowIcon,
      "data-img-src": _vm.arrowIcon,
      "weex-type": "image"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16159dce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16159dce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-item/index.vue
// module id = 569
// module chunks = 0 1